export const createPlatformSegmentJsonSchema = {
  type: "object",
  title: "Create Platform Segment",
  properties: {
    name: {
      type: "string",
      title: "Segment Name",
      minLength: 1,
      maxLength: 255,
    },
    status: {
      type: "string",
      title: "Status",
      default: "DRAFT",
      items: {
        options: [
          { id: "ENABLED", displayText: "Active" },
          { id: "DRAFT", displayText: "Inactive" },
        ],
      },
      options: [
        { id: "ENABLED", displayText: "Active" },
        { id: "DRAFT", displayText: "Inactive" },
      ],
    },
  },
  required: ["name"],
};

export const createPlatformSegmentUISchema = {
  type: "SimpleGroup",
  elements: [
    {
      type: "VerticalLayout",
      elements: [
        { type: "Control", scope: "#/properties/name" },
        {
          type: "Control",
          scope: "#/properties/status",
          component: "muiSelect",
          selection: "single",
        },
      ],
    },
  ],
};
